import Link from "next/link";
import { Handshake } from "lucide-react";

export function ProgramsLightCTA() {
  return (
    <section className="border-t border-[var(--site-border)] bg-[var(--site-surface-alt)] py-12 md:py-16">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 md:flex-row md:px-6">
        <div className="flex items-center gap-4 text-center md:text-left">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[var(--site-surface)] text-[var(--site-primary)] shadow-sm">
            <Handshake size={28} aria-hidden />
          </div>
          <p className="max-w-xl text-lg font-medium text-[var(--site-text)] md:text-xl">
            Together, we can build a compassionate, healthy, and sustainable
            world.
          </p>
        </div>
        <Link href="/donate" className="site-btn-primary shrink-0">
          <Handshake size={16} aria-hidden />
          Support Our Mission
        </Link>
      </div>
    </section>
  );
}
